import { DirectoryGroup, DirectoryUser } from "./models";
import { toString } from '../../model/utility';
import { RequestCache } from "../../cache/request.cache";


export class DirectoryCache {
  private static readonly INSTANCE = new DirectoryCache();
  static getInstance(): DirectoryCache { return this.INSTANCE; }
  
  private readonly users = new Map<string, DirectoryUser>();
  private readonly groups = new Map<string, DirectoryGroup>();
  readonly countRequestCache = new RequestCache<number>();

  getUser(id: number | string): DirectoryUser { return this.users.get(toString(id)); }
  getGroup(id: number | string): DirectoryGroup { return this.groups.get(toString(id)); }

  getAllUsers(directoryId: string): DirectoryUser[] {
    const all = Array.from(this.users.values());
    return all.filter(x => x.directoryId === directoryId);
  }

  getAllGroups(directoryId: string): DirectoryGroup[] {
    const all = Array.from(this.groups.values());
    return all.filter(x => x.directoryId === directoryId);
  }

  putUser(item: DirectoryUser) {
    // don't replace an existing user with a missing one
    if (item.isMissing === true && !!this.getUser(item.id)) return;
    this.users.set(toString(item.id), item);
  }

  putGroup(item: DirectoryGroup) {
    // don't replace an existing group with a linked group
    if (item.isLinked === true && !!this.getGroup(item.id)) return;
    // don't replace an existing group with a missing one
    if (item.isMissing === true && !!this.getGroup(item.id)) return;
    this.groups.set(toString(item.id), item);
  }
}